import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { adminApi, setToken, errorText } from "./adminApi";
import { LogoMark } from "@/components/site/Logo";

export const AdminLogin = ({ onDone }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await adminApi.login(email, password);
      setToken(data.token);
      onDone(data.user);
    } catch (ex) {
      setErr(errorText(ex));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid place-items-center px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="glass w-full max-w-sm rounded-3xl p-8">
        <LogoMark className="w-12 h-12" />
        <h1 className="font-display text-3xl font-extrabold mt-6">Admin sign in</h1>
        <p className="text-sm text-slate-400 mt-1 flex items-center gap-1.5"><Lock size={14} /> Private dashboard</p>
        <label className="block text-xs text-slate-400 mt-8">Email
          <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-1.5 w-full rounded-xl bg-white/5 border border-white/10 px-4 py-3 text-sm text-white focus:outline-none focus:border-[#FF2A8D]" />
        </label>
        <label className="block text-xs text-slate-400 mt-4">Password
          <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 w-full rounded-xl bg-white/5 border border-white/10 px-4 py-3 text-sm text-white focus:outline-none focus:border-[#FF2A8D]" />
        </label>
        {err && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{err}</p>}
        <button data-testid="admin-login-submit" disabled={busy}
          className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#FF2A8D] hover:bg-[#FF54A5] py-3.5 font-semibold transition-colors disabled:opacity-60">
          {busy && <Loader2 className="animate-spin" size={18} />} Sign in
        </button>
      </form>
    </div>
  );
};
